export default {"src":"/_next/static/media/store-icon.51a2fecf.gif","height":400,"width":400,"blurWidth":0,"blurHeight":0};